import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { Location } from 'history';
import b from 'b_';

import './projects-page.css';

import PageMeta from '@components/page-meta';
import { Project } from '@interfaces/outreach-entity';
import PaginationMeta from '@interfaces/pagination-meta';
import { PaginationWrapperProps } from '@components/pagination-wrapper';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';
import { fetchProjects, fetchProjectsFilters } from 'client/ducks/projects-page/actions';
import { formatQuery, parseQuery } from 'client/helpers/url';
import ProjectItem from '@components/project-item/project-item';
import ShowMore from '@components/pagination-wrapper/show-more';
import ProjectsPageStub from 'pages/projects-page/projects-page-stub';
import YearFilter from '@components/year-filter/year-filter';

import outreachConfig from '../outreach/page-config.json';

export interface DispatchProps {
    fetchProjects(params: OutreachRequestParams): void;
    fetchFilters(): void;
}

interface StateProps {
    hasMore: boolean;
    years: number[];
    rows: Project[];
    meta: PaginationMeta;
    listParams: OutreachRequestParams;
    isLoading: boolean;
}

export type Props = StateProps & DispatchProps & PaginationWrapperProps & RouteComponentProps<any>;

const class_ = b.with('projects-page');

export default class ProjectsPage extends Component<Props> {
    public static asyncFetchData({ dispatch, location }: AsyncFetchDataProps) {
        const params = ProjectsPage.getRequestParams(location);

        dispatch(fetchProjects(params));
        dispatch(fetchProjectsFilters());
    }

    public static getRequestParams(location: Location, page = 1): OutreachRequestParams {
        const query = parseQuery(location.search);
        const year = query.get('year');
        const params: OutreachRequestParams = { page };

        if (year) {
            params.year = parseInt(year, 10);
        }

        return params;
    }

    public componentDidMount() {
        const { rows, years, location, listParams } = this.props;
        const currentParams = ProjectsPage.getRequestParams(location);

        if (!rows.length || (listParams.year !== currentParams.year)) {
            this.fetchProjects();
        }

        if (!years.length) {
            this.props.fetchFilters();
        }
    }

    public fetchProjects(params: OutreachRequestParams = {}) {
        const { location } = this.props;
        const currentParams = ProjectsPage.getRequestParams(location);

        this.props.fetchProjects({ ...currentParams, ...params });
    }

    public onShowMoreClick = () => {
        const { meta } = this.props;
        const { pageNumber } = meta;

        this.fetchProjects({ page: 1 + pageNumber });
    };

    public onYearChange = (year: number | undefined) => {
        const query = formatQuery({ year });

        this.fetchProjects({ year });
        this.props.history.push(`/projects${query}`);
    };

    public renderList() {
        const { rows, hasMore } = this.props;

        return (
            <div className={class_('list')} key="list">
                {rows.map(project =>
                    <ProjectItem
                        type="horizontal"
                        key={project.id}
                        entity={project}
                    />
                )}
                {hasMore && (
                    <ShowMore onClick={this.onShowMoreClick} />
                )}
            </div>
        );
    }

    public render() {
        const { years, rows, isLoading, location } = this.props;
        const query = parseQuery(location.search);
        const year = query.get('year') || undefined;

        return (
            <div className={class_()}>
                <PageMeta title="Selected projects" description={outreachConfig.meta.description} />
                <div className={class_('top')}>
                    <h1 className="block__title">
                        Selected projects
                    </h1>
                    {years.length > 1 && (
                        <YearFilter
                            years={years}
                            selectedYear={year}
                            onYearChange={this.onYearChange}
                        />
                    )}
                </div>

                {isLoading && !rows.length
                    ? <ProjectsPageStub key="stub" />
                    : this.renderList()
                }
            </div>
        );
    }
}
